export default "__VITE_ASSET__49f45e2c__"